export const SIGN_UP_START = 'SIGN_UP_START';
export const SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS';
export const SIGN_UP_FAILED = 'SIGN_UP_FAILED';

export const VERIFY_ACCOUNT = 'VERIFY_ACCOUNT';
export const VERIFY_ACCOUNT_START = 'VERIFY_ACCOUNT_START';
export const VERIFY_ACCOUNT_SUCCESS = 'VERIFY_ACCOUNT_SUCCESS';
export const VERIFY_ACCOUNT_FAILED = 'VERIFY_ACCOUNT_FAILED';

export const RESEND_ACCOUNT_VERIFICATION_CODE = 'RESEND_ACCOUNT_VERIFICATION_CODE';
export const RESEND_ACCOUNT_VERIFICATION_CODE_START = 'RESEND_ACCOUNT_VERIFICATION_CODE_START';
export const RESEND_ACCOUNT_VERIFICATION_CODE_SUCCESS = 'RESEND_ACCOUNT_VERIFICATION_CODE_SUCCESS';
export const RESEND_ACCOUNT_VERIFICATION_CODE_FAILED = 'RESEND_ACCOUNT_VERIFICATION_CODE_FAILED';

export const ACCOUNT_NEEDS_VERIFICATION = 'ACCOUNT_NEEDS_VERIFICATION';

export const SIGN_IN = 'SIGN_IN';
export const SIGN_IN_START = 'SIGN_IN_START';
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS';
export const SIGN_IN_FAILED = 'SIGN_IN_FAILED';
export const SESSION_TOKEN_SUCCESS = 'SESSION_TOKEN_SUCCESS';
export const SESSION_TOKEN_FAILED = 'SESSION_TOKEN_FAILED';

export const LOGOUT = 'LOGOUT';
export const LOGOUT_START = 'LOGOUT_START';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILED = 'LOGOUT_FAILED';

export const REQUEST_PASSWORD_RESET = 'REQUEST_PASSWORD_RESET';
export const REQUEST_PASSWORD_RESET_START = 'REQUEST_PASSWORD_RESET_START';
export const REQUEST_PASSWORD_RESET_SUCCESS = 'REQUEST_PASSWORD_RESET_SUCCESS';
export const REQUEST_PASSWORD_RESET_FAILED = 'REQUEST_PASSWORD_RESET_FAILED';
export const RETURN_TO_PASSWORD_RESET_REQUEST = 'RETURN_TO_PASSWORD_RESET_REQUEST';

export const RESET_AUTH_DATA = 'RESET_AUTH_DATA';

export const UPLOAD_PROFILE_IMAGE = 'UPLOAD_PROFILE_IMAGE';
export const UPLOAD_PROFILE_IMAGE_START = 'UPLOAD_PROFILE_IMAGE_START';
export const UPLOAD_PROFILE_IMAGE_FAILED = 'UPLOAD_PROFILE_IMAGE_FAILED';
export const SET_PROFILE_IMAGE = 'SET_PROFILE_IMAGE';

export const INIT_PROFILE_FORM = 'INIT_PROFILE_FORM';
export const CLOSE_PROFILE_FORM = 'CLOSE_PROFILE_FORM';

export const SUBMIT_PROFILE_START = 'SUBMIT_PROFILE_START';
export const SUBMIT_PROFILE_SUCCESS = 'SUBMIT_PROFILE_SUCCESS';
export const SUBMIT_PROFILE_FAILED = 'SUBMIT_PROFILE_FAILED';

export const FETCH_PROFILE_SUCCESS = 'FETCH_PROFILE_SUCCESS';
export const FETCH_PROFILE_FAILED = 'FETCH_PROFILE_FAILED';
export const FETCH_PROFILE_START = 'FETCH_PROFILE_START';
export const FETCH_PROFILE_RETURNS_NEW_USER = 'FETCH_PROFILE_RETURNS_NEW_USER';
export const SET_MANAGED_USERS = 'SET_MANAGED_USERS';
export const UPDATE_POSTING_AS = 'UPDATE_POSTING_AS';
export const REVERT_TO_SIGNED_IN_AS = 'REVERT_TO_SIGNED_IN_AS';

export const UPDATE_EMAIL = 'UPDATE_EMAIL';
export const UPDATE_EMAIL_START = 'UPDATE_EMAIL_START';
export const UPDATE_EMAIL_SUCCESS = 'UPDATE_EMAIL_SUCCESS';
export const UPDATE_EMAIL_FAILED = 'UPDATE_EMAIL_FAILED';

export const UPDATE_PASSWORD = 'UPDATE_PASSWORD';
export const UPDATE_PASSWORD_START = 'UPDATE_PASSWORD_START';
export const UPDATE_PASSWORD_SUCCESS = 'UPDATE_PASSWORD_SUCCESS';
export const UPDATE_PASSWORD_FAILED = 'UPDATE_PASSWORD_FAILED';

export const CREATE_MANAGED_ACCOUNT_START = 'CREATE_MANAGED_ACCOUNT_START';
export const CREATE_MANAGED_ACCOUNT_SUCCESS = 'CREATE_MANAGED_ACCOUNT_SUCCESS';
export const CREATE_MANAGED_ACCOUNT_FAILED = 'CREATE_MANAGED_ACCOUNT_FAILED';

export const DELETE_MANAGED_ACCOUNT = 'DELETE_MANAGED_ACCOUNT';
export const DELETE_MANAGED_ACCOUNT_START = 'DELETE_MANAGED_ACCOUNT_START';
export const DELETE_MANAGED_ACCOUNT_FAILED = 'DELETE_MANAGED_ACCOUNT_FAILED';
export const DELETE_MANAGED_ACCOUNT_SUCCESS = 'DELETE_MANAGED_ACCOUNT_SUCCESS';

export const USER_SEARCH = 'USER_SEARCH';
export const USER_SEARCH_START = 'USER_SEARCH_START';
export const USER_SEARCH_SUCCESS = 'USER_SEARCH_SUCCESS';
export const USER_SEARCH_FAILED = 'USER_SEARCH_FAILED';

export const USER_EDIT_EMOJI_TONE = 'USER_EDIT_EMOJI_TONE';

export const FETCH_LOG = 'FETCH_LOG';
export const FETCH_LOG_START = 'FETCH_LOG_START';
export const FETCH_LOG_SUCCESS = 'FETCH_LOG_SUCCESS';
export const FETCH_LOG_FAILED = 'FETCH_LOG_FAILED';
export const CLEAR_ALL_LOGS = 'CLEAR_ALL_LOGS';

export const FETCH_MULTI_VIEW_COLUMNS = 'FETCH_MULTI_VIEW_COLUMNS';
export const FETCH_MULTI_VIEW_COLUMNS_START = 'FETCH_MULTI_VIEW_COLUMNS_START';
export const FETCH_MULTI_VIEW_COLUMNS_SUCCESS = 'FETCH_MULTI_VIEW_COLUMNS_SUCCESS';
export const FETCH_MULTI_VIEW_COLUMNS_FAILED = 'FETCH_MULTI_VIEW_COLUMNS_FAILED';
export const REMOVE_MULTI_VIEW_COLUMNS = 'REMOVE_MULTI_VIEW_COLUMNS';

export const CREATE_LOG = 'CREATE_LOG';
export const CREATE_INITIAL_LOG = 'CREATE_INITIAL_LOG';
export const CREATE_LOG_START = 'CREATE_LOG_START';
export const CREATE_LOG_FAILED = 'CREATE_LOG_FAILED';
export const CREATE_LOG_SUCCESS = 'CREATE_LOG_SUCCESS';

export const LOG_ADD_REMOVE_MEMBERS = 'LOG_ADD_REMOVE_MEMBERS';
export const LOG_ADD_REMOVE_MEMBERS_START = 'LOG_ADD_REMOVE_MEMBERS_START';
export const LOG_ADD_REMOVE_MEMBERS_SUCCESS = 'LOG_ADD_REMOVE_MEMBERS_SUCCESS';
export const LOG_ADD_REMOVE_MEMBERS_FAILED = 'LOG_ADD_REMOVE_MEMBERS_FAILED';

export const LOG_REMOVE_ARCHIVED_USERS = 'LOG_REMOVE_ARCHIVED_USERS';
export const LOG_REMOVE_ARCHIVED_USERS_START = 'LOG_REMOVE_ARCHIVED_USERS_START';
export const LOG_REMOVE_ARCHIVED_USERS_SUCCESS = 'LOG_REMOVE_ARCHIVED_USERS_SUCCESS';
export const LOG_REMOVE_ARCHIVED_USERS_FAILED = 'LOG_REMOVE_ARCHIVED_USERS_FAILED';

export const LOG_INVITE_NEW_USERS = 'LOG_INVITE_NEW_USERS';
export const LOG_INVITE_NEW_USERS_START = 'LOG_INVITE_NEW_USERS_START';
export const LOG_INVITE_NEW_USERS_SUCCESS = 'LOG_INVITE_USERS_SUCCESS';
export const LOG_INVITE_NEW_USERS_FAILED = 'LOG_INVITE_NEW_USERS_FAILED';

export const LOG_UPDATE_USER_ACCESS = 'LOG_UPDATE_USER_ACCESS';
export const LOG_UPDATE_USER_ACCESS_START = 'LOG_UPDATE_USER_ACCESS_START';
export const LOG_UPDATE_USER_ACCESS_SUCCESS = 'LOG_UPDATE_USER_ACCESS_SUCCESS';
export const LOG_UPDATE_USER_ACCESS_FAILED = 'LOG_UPDATE_USER_ACCESS_FAILED';

export const LOG_TRANSFER_HOST = 'LOG_TRANSFER_HOST';
export const LOG_TRANSFER_HOST_START = 'LOG_TRANSFER_HOST_START';
export const LOG_TRANSFER_HOST_SUCCESS = 'LOG_TRANSFER_HOST_SUCCESS';
export const LOG_TRANSFER_HOST_FAILED = 'LOG_TRANSFER_HOST_FAILED';

export const LOG_LEAVE = 'LOG_LEAVE';
export const LOG_LEAVE_START = 'LOG_LEAVE_START';
export const LOG_LEAVE_SUCCESS = 'LOG_LEAVE_SUCCESS';
export const LOG_LEAVE_FAILED = 'LOG_LEAVE_FAILED';

export const LOG_UPDATE = 'LOG_UPDATE';
export const LOG_UPDATE_START = 'LOG_UPDATE_START';
export const LOG_UPDATE_SUCCESS = 'LOG_UPDATE_SUCCESS';
export const LOG_UPDATE_FAILED = 'LOG_UPDATE_FAILED';

export const FETCH_LOGS_DETAILS = 'FETCH_LOGS_DETAILS';
export const FETCH_LOGS_DETAILS_START = 'FETCH_LOGS_DETAILS_START';
export const FETCH_LOGS_DETAILS_SUCCESS = 'FETCH_LOGS_DETAILS_SUCCESS';
export const FETCH_LOGS_DETAILS_FAILED = 'FETCH_LOGS_DETAILS_FAILED';

export const FETCH_MEMBERS_FOR_LOGS = 'FETCH_MEMBERS_FOR_LOGS';
export const FETCH_MEMBERS_FOR_LOGS_START = 'FETCH_MEMBERS_FOR_LOGS_START';
export const FETCH_MEMBERS_FOR_LOGS_SUCCESS = 'FETCH_MEMBERS_FOR_LOGS_SUCCESS';
export const FETCH_MEMBERS_FOR_LOGS_FAILED = 'FETCH_MEMBERS_FOR_LOGS_FAILED';

export const TOGGLE_GIFTS_DRAFTS_MODAL = 'TOGGLE_GIFTS_DRAFTS_MODAL';

export const FETCH_TAGS_FOR_LOGS = 'FETCH_TAGS_FOR_LOGS';
export const FETCH_TAGS_START = 'FETCH_TAGS_START';
export const FETCH_TAGS_SUCCESS = 'FETCH_TAGS_SUCCESS';
export const FETCH_TAGS_FAILED = 'FETCH_TAGS_FAILED';

export const UPLOAD_POST_IMAGE = 'UPLOAD_POST_IMAGE';
export const UPLOAD_POST_IMAGE_START = 'UPLOAD_POST_IMAGE_START';
export const UPLOAD_POST_IMAGE_FAILED = 'UPLOAD_POST_IMAGE_FAILED';
export const UPLOAD_POST_IMAGE_SUCCESS = 'UPLOAD_POST_IMAGE_SUCCESS';
export const CLEAR_COMMENT_IMAGES = 'CLEAR_COMMENT_IMAGES';

export const REORDER_POST_IMAGES = 'REORDER_POST_IMAGES';

export const INIT_POST_FORM_START = 'INIT_POST_FORM_START';
export const INIT_POST_FORM = 'INIT_POST_FORM';
export const ADD_POST = 'ADD_POST';
export const ADD_POST_START = 'ADD_POST_START';
export const ADD_POST_SUCCESS = 'ADD_POST_SUCCESS';
export const ADD_POST_FAILED = 'ADD_POST_FAILED';
export const REMOVE_POST_IMAGE = 'REMOVE_POST_IMAGE';
export const FETCH_POST_START = 'FETCH_POST_START';
export const FETCH_POST = 'FETCH_POST';
export const FETCH_POST_SUCCESS = 'FETCH_POST_SUCCESS';
export const FETCH_POST_FAILED = 'FETCH_POST_FAILED';

export const SET_PREVIEW_POST = 'SET_PREVIEW_POST';
export const RETURN_TO_GIFT_POST_FORM = 'RETURN_TO_GIFT_POST_FORM';

export const DELETE_POST = 'DELETE_POST';
export const DELETE_POST_START = 'DELETE_POST_START';
export const DELETE_POST_SUCCESS = 'DELETE_POST_SUCCESS';
export const DELETE_POST_FAILED = 'DELETE_POST_FAILED';
export const EDIT_POST_START = 'EDIT_POST_START';
export const EDIT_POST = 'EDIT_POST';
export const EDIT_POST_SUCCESS = 'EDIT_POST_SUCCESS';
export const EDIT_POST_FAILED = 'EDIT_POST_FAILED';

export const ADD_COMMENT_IMAGE_TO_POST = 'ADD_COMMENT_IMAGE_TO_POST';
export const ADD_COMMENT_IMAGE_TO_POST_START = 'ADD_COMMENT_IMAGE_TO_POST_START';
export const ADD_COMMENT_IMAGE_TO_POST_SUCCESS = 'ADD_COMMENT_IMAGE_TO_POST_SUCCESS';
export const ADD_COMMENT_IMAGE_TO_POST_FAILED = 'ADD_COMMENT_IMAGE_TO_POST_FAILED';

export const CLOSE_POST_FORM = 'CLOSE_POST_FORM';

export const DUPLICATE_POST = 'DUPLICATE_POST';
export const DUPLICATE_POST_START = 'DUPLICATE_POST_START';
export const DUPLICATE_POST_SUCCESS = 'DUPLICATE_POST_SUCCESS';
export const DUPLICATE_POST_FAILED = 'DUPLICATE_POST_FAILED';

export const SUBMIT_POST_COMMENT = 'SUBMIT_POST_COMMENT';
export const SUBMIT_POST_COMMENT_START = 'SUBMIT_POST_COMMENT_START';
export const SUBMIT_POST_COMMENT_SUCCESS = 'SUBMIT_POST_COMMENT_SUCCESS';
export const SUBMIT_POST_COMMENT_FAILED = 'SUBMIT_POST_COMMENT_FAILED';

export const ENTRY_COMMENT_UPDATE = 'ENTRY_COMMENT_UPDATE';
export const ENTRY_COMMENT_UPDATE_START = 'ENTRY_COMMENT_UPDATE_START';
export const ENTRY_COMMENT_UPDATE_SUCCESS = 'ENTRY_COMMENT_UPDATE_SUCCESS';
export const ENTRY_COMMENT_UPDATE_FAILED = 'ENTRY_COMMENT_UPDATE_FAILED';

export const FETCH_GROUP_POSTS_LIST = 'FETCH_GROUP_POSTS_LIST';
export const FETCH_GROUP_POSTS_LIST_START = 'FETCH_GROUP_POSTS_LIST_START';
export const FETCH_GROUP_POSTS_LIST_SUCCESS = 'FETCH_GROUP_POSTS_LIST_SUCCESS';
export const FETCH_GROUP_POSTS_LIST_FAILED = 'FETCH_GROUP_POSTS_LIST_FAILED';

export const FETCH_DRAFTS = 'FETCH_DRAFTS';
export const FETCH_DRAFTS_START = 'FETCH_DRAFTS_START';
export const FETCH_DRAFTS_SUCCESS = 'FETCH_DRAFTS_SUCCESS';
export const FETCH_DRAFTS_FAILED = 'FETCH_DRAFTS_FAILED';

export const TOGGLE_POST_DETAIL_NAV_OPTIONS = 'TOGGLE_POST_DETAIL_NAV_OPTIONS';

export const TOGGLE_SIDE_DRAWER = 'TOGGLE_SIDE_DRAWER';
export const GET_AVAILABLE_SERVERS_START = 'GET_AVAILABLE_SERVERS_START';
export const GET_AVAILABLE_SERVERS_SUCCESS = 'GET_AVAILABLE_SERVERS_SUCCESS';
export const GET_AVAILABLE_SERVERS_FAILED = 'GET_AVAILABLE_SERVERS_FAILED';
export const SET_SELECTED_SERVER_START = 'SET_SELECTED_SERVER_START';
export const SET_SELECTED_SERVER_SUCCESS = 'SET_SELECTED_SERVER_SUCCESS';

export const LOG_APP_ERROR = 'LOG_APP_ERROR';
export const CLEAR_APP_ERROR = 'CLEAR_APP_ERROR';

export const ADD_IMPORTANT_PLACE = 'ADD_IMPORTANT_PLACE';
export const ADD_IMPORTANT_PLACE_START = 'ADD_IMPORTANT_PLACE_START';
export const ADD_IMPORTANT_PLACE_SUCCESS = 'ADD_IMPORTANT_PLACE_SUCCESS';
export const ADD_IMPORTANT_PLACE_FAILED = 'ADD_IMPORTANT_PLACE_FAILED';
export const UPDATE_IMPORTANT_PLACE = 'UPDATE_IMPORTANT_PLACE';
export const UPDATE_IMPORTANT_PLACE_START = 'UPDATE_IMPORTANT_PLACE_START';
export const UPDATE_IMPORTANT_PLACE_SUCCESS = 'UPDATE_IMPORTANT_PLACE_SUCCESS';
export const UPDATE_IMPORTANT_PLACE_FAILED = 'UPDATE_IMPORTANT_PLACE_FAILED';

export const FETCH_IMPORTANT_PLACES = 'FETCH_IMPORTANT_PLACES';
export const FETCH_IMPORTANT_PLACES_START = 'FETCH_IMPORTANT_PLACES_START';
export const FETCH_IMPORTANT_PLACES_SUCCESS = 'FETCH_IMPORTANT_PLACES_SUCCESS';
export const FETCH_IMPORTANT_PLACES_FAILED = 'FETCH_IMPORTANT_PLACES_FAILED';

export const FETCH_RECENT_PLACES = 'FETCH_RECENT_PLACES';
export const FETCH_RECENT_PLACES_START = 'FETCH_RECENT_PLACES_START';
export const FETCH_RECENT_PLACES_SUCCESS = 'FETCH_RECENT_PLACES_SUCCESS';
export const FETCH_RECENT_PLACES_FAILED = 'FETCH_RECENT_PLACES_FAILED';

export const FETCH_USER_RECENT_ACTIVITY = 'FETCH_USER_RECENT_ACTIVITY';
export const FETCH_USER_RECENT_ACTIVITY_START = 'FETCH_USER_RECENT_ACTIVITY_START';
export const FETCH_USER_RECENT_ACTIVITY_SUCCESS = 'FETCH_USER_RECENT_ACTIVITY_SUCCESS';
export const FETCH_USER_RECENT_ACTIVITY_FAILED = 'FETCH_USER_RECENT_ACTIVITY_FAILED';

export const UPDATE_SCROLL_TO_TOP_OF_CHILD = 'UPDATE_SCROLL_TO_TOP_OF_CHILD';

export const FETCH_HELP_CONTENT = 'FETCH_HELP_CONTENT';
export const FETCH_HELP_CONTENT_START = 'FETCH_HELP_CONTENT_START';
export const FETCH_HELP_CONTENT_SUCCESS = 'FETCH_HELP_CONTENT_SUCCESS';
export const FETCH_HELP_CONTENT_FAILED = 'FETCH_HELP_CONTENT_FAILED';
